import React, { PureComponent } from 'react';
import { StyleSheet, View } from 'react-native';
import { createContainer } from '@dbk-legacy/muster/react';
import Text, { Small, H1, H3 } from '@dbk/ui-text';
import { EditCircle } from '@dbk/ui-icons';
import { FormattedMessage } from '@dbk-legacy/format'
import debounce from 'lodash/debounce';
import {
  NavigationListItem,
  NavigationListItemHeader,
  NavigationListItemFooter,
} from '@dbk/ui-list';
import { FormattedNumber } from '@dbk/format';
import { ShortDate } from '@dbk/ui-dates';
import { Checkbox, TextInput } from '@dbk/ui-forms';
import Button from '@dbk/ui-buttons';
import PymtDetails from './payment-details/payment-details';
import PymtAmtDetails from './payment-amount-details/payment-amount-details';
import { LoadingCircle } from '../../../components/common/loading';
import PaymentError from '../payment-error';
import FormBackConfirmModal from '../../../components/common/form-back-confirm-modal'
import styles from './payment-form.styles';
import { RM_REGION_UK, ROUTES } from '../../../constants'
import { PALETTE, WARNING_ICON,EBANKINGWEBUK, KEY_CODE } from '../../../constants';
import { isEqual } from 'lodash';
import { getModifiedTemplateObject, getSelectedTemplate } from '../payment-utils';
import Modal from '@dbk/ui-modal';
import { WarningIcon } from '../../../components/common/icons';
import {validateBenefName, isEmpty} from '../../payments/payment-destination/utils';
import envConfig from '../../../../db-env-build';
 
const {
  DESTINATION,
  TX_SUMMARY,
  DEBIT_ACCOUNT_LIST,
  ADD_BENEFICIARY
} = ROUTES.PAYMENT
 
const alignRightStyle = { flex: 1, alignItems: 'flex-end', color: PALETTE.primaryText };
const getBeneficiaryName = (firstName, lastName) => {
  return (firstName || '') + (firstName && lastName ? ' ' : '') + (lastName || '')
}
 
const defaultValue = { accBalance: null, accName: null, currency: null, accNo: null, asOfDate: null }
const getBalance = balance => typeof balance === 'string' ?
  Number(balance.replace(/,/g, '')) : balance
 
class PaymentForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentTemplateName: this.props.payments.templateName,
      warnModifiedTemplate: false
    }
  }
 
  componentDidMount(){
    this.props.payments.setSaveModifiedTemplate(false);
    this.props.payments.setBeneficiaryIdToUpdate(null);
    this.props.payments.setExistingBeneficiaryId(null);
  }

  componentDidUpdate(){
    if(document.querySelector('button.proceed')){
      document.querySelector('button.proceed').focus();
    }
    if(document.querySelector('.warningPaymentTemplate')){
      document.querySelector('.warningPaymentTemplate').focus();
    }
  }
  
  onValidateClick = () => {
    const {
      payments: { isPaymentTemplateFlow, isSaveEnabled }
    } = this.props;
    if (isPaymentTemplateFlow) {
      const {
        payments: { setTemplateName, selectedPaymentTemplate, amount, paymentReason, selectedBeneficiaryBank, selectedDebitAcnt, selectedCreditAcnt, selectedCurrency, selectedCost }
      } = this.props;

      let { payments: { remarks } }= this.props;

      if(paymentReason && !isEmpty(paymentReason)) {
        remarks = `${paymentReason}-${remarks}`;
      }
      const {
        currentTemplateName
      } = this.state;
      if(isSaveEnabled){
        setTemplateName(currentTemplateName);
      }else{
        setTemplateName(selectedPaymentTemplate.templateName);
      }
      const toNumber = amt =>
        typeof amt === 'number' ? amt : Number(amt.replace(/[^0-9.]/g, ''))
 
      if (selectedPaymentTemplate) {
 
        const paymentModifiedTemp = getModifiedTemplateObject(({
          amount: toNumber(amount),
          remarks: remarks==='' ? null : remarks,
          from: selectedDebitAcnt,
          to: selectedBeneficiaryBank || selectedCreditAcnt,
          currency: selectedCurrency,
          cost: selectedCost,
          templateName: currentTemplateName
        }))
        const selectedPaymentTemp = getSelectedTemplate(selectedPaymentTemplate);
        // if checkbox is enabled dont show the warning confirmation save message
        if (!isEqual(selectedPaymentTemp, paymentModifiedTemp) && !isSaveEnabled) {
          this.setState({ warnModifiedTemplate: true });
          return;
        }
      }
    }
    this.props.payments.validatePayment();
    // todo: route depends on dwoMessages
    this.props.changePage(TX_SUMMARY);
  }
 
  selectBeneficiary = async (e) => {
    const {
      changePage,
      payments: { paymentType, loadCreditAccountList,  isModifyFlow }
    } = this.props;
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      if((envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK) && paymentType.includes('domestic') && isModifyFlow){ //WMCE-39640 +WMCE-38994
        return;
      }
      await this.props.payments.setDebitAccountFlow(false);
      if (paymentType.includes('internal')) loadCreditAccountList()
      else changePage(DESTINATION);
    }
  }
 
  renderSelfAccount = (data1, messages) => {
    const data = data1 != null ? data1 : defaultValue;
    const balance = data != null ? getBalance(data.accBalance) : null;
    return (
      <React.Fragment>
 
        <NavigationListItemFooter
          tabIndex={data.accName?0:-1}
          color={PALETTE.secondaryActive}>
          {data.accName}
          <View style={alignRightStyle}>
            {balance &&
              <Text size="small">
                <FormattedNumber
                  color={PALETTE.secondaryActive}
                  value={balance}
                  style="currency"
                  currencyDisplay="code"
                  currency={data.currency}
                />
              </Text>}
          </View>
        </NavigationListItemFooter>
        <NavigationListItemFooter
          tabIndex={data.accNo?0:-1}
          color={PALETTE.secondaryActive}>
          {data.accNo}
          <View style={alignRightStyle}>
            <Small size="small" >
              <FormattedMessage
                id='app.payments.summary.asOf'
                values={{ asOfDate: data.asOfDate }} />
            </Small>
          </View>
        </NavigationListItemFooter>
        <NavigationListItemFooter tabIndex={data.ibanNo?0:-1}>
          <Text size="small" style={{ color: PALETTE.secondaryActive }}>
            {data.ibanNo}
          </Text>
        </NavigationListItemFooter>
        <NavigationListItemFooter tabIndex={data.pfId?0:-1}>
          <Text size="small" style={{ color: PALETTE.secondaryActive }}>
            {messages['app.payments.portfolio.text'] + ' ' + data.pfId}
          </Text>
        </NavigationListItemFooter>
      </React.Fragment>
    )
  }
 
  navigateToSelectDebit = async(isInternal, e) => {
    if((e && e.keyCode && (e.keyCode === KEY_CODE.ENTER_KEY || e.keyCode === KEY_CODE.SPACE_KEY)) || (!e)){
      await this.props.payments.setDebitAccountFlow(true);
      this.props.payments.setModifyDebitAcntFlag(true);
      if (isInternal)
        this.props.payments.loadDebitAccountList();
      else
        this.props.changePage(DEBIT_ACCOUNT_LIST);
  
      this.props.payments.setIsPymtAddNewBenef(false);
    }
  }
 
  confirmFormBackConfirm = () => {
    const {payments: { isCashFlow, isModifyFlow, setDisableTabs,isCashPaymentFlow }} = this.props;
      if(isCashFlow  &&  !isModifyFlow){ 
        setDisableTabs(false);
        if(isCashPaymentFlow){   //WMCE-47749- To switch over cash account tab
        this.props.payments.setIsCashPaymentFlow(false);
        this.props.changePage(ROUTES.CASH_ACCOUNTS.SUMMARY_CASH_ACCOUNTS_ROUTE); 
        }
        else{
        this.props.portfolio.setAssetClassName('liquidity');
        this.props.changePage(ROUTES.PORTFOLIO.DASHBOARD, true);
        this.props.changePage(ROUTES.PORTFOLIO.GENERIC_ASSETS);
        }
      }else{
        this.props.changePage(ROUTES.PAYMENT.DASHBOARD)
      }
  }
 
  renderFromAccount = (selectedDebitAcnt, messages, isInternal) => (
    <NavigationListItem className="full-height" inverse hasArrow={false} onKeyDown={(e) => this.navigateToSelectDebit(isInternal, e)}  onClick={() => this.navigateToSelectDebit(isInternal)} style={{ borderColor: PALETTE.primaryActive }} tabIndex={-1}>
      <NavigationListItemHeader color={PALETTE.primaryText} tabIndex={0}>
        {messages['app.payments.destination.from']}
      </NavigationListItemHeader>
      {selectedDebitAcnt != null ? this.renderSelfAccount(selectedDebitAcnt, messages) :
        <NavigationListItemFooter color={PALETTE.secondaryActive} tabIndex={0}>{messages['app.payment.pageTitle.debitAccount']}</NavigationListItemFooter>}
    </NavigationListItem>
  )
 
  renderToAccount = (account, messages, isInternal, paymentType) => {
    let content;
    const {
      auth: {addBeneficiaryDisabled}} = this.props;
    if (!account) {
      // render placeholder when no account selected
      const msg = isInternal ?
        messages['app.payments.selectCreditAcc'] :
        messages['app.payment.pageTitle.selectBeneficiary']
      content = <NavigationListItemFooter tabIndex={0}><Text primary >{msg}</Text></NavigationListItemFooter>
    } else if (isInternal) {
      // internal
      content = this.renderSelfAccount(account, messages)
    } else {
      // non-internal
      const {
        beneficiaryName,
        firstName,
        lastName,
        accountNo,
        ibanNo,
        bank,
        swiftCode = '',
        ntnlId,
        address1,
        address2,
        address3,
        city,
        cityName,
        postalCode,
        country, 
        sortCode
      } = account;
      let swiftOrNtnlId = bank + (swiftCode?(' ('+swiftCode+')'):'')
      if(paymentType.includes('domestic')){
        swiftOrNtnlId = bank + (ntnlId?(' ('+ntnlId+')'):'')
      }
      let sortCodeFormat;
      if(sortCode) {
        if(sortCode.length === 6) {
          sortCodeFormat = `${sortCode.slice(0,2)}-${sortCode.slice(2,4)}-${sortCode.slice(4,6)}`;
        }
        if(sortCode.length === 8) {
          sortCodeFormat = sortCode;
        }
      }

      const bankSwift = swiftOrNtnlId
      content = (
        <React.Fragment>
          {
            envConfig.envConfig ===EBANKINGWEBUK && paymentType.includes('domestic') ?
              <React.Fragment >
                    <NavigationListItemFooter tabIndex={beneficiaryName || getBeneficiaryName(firstName, lastName)?"0":"-1"}>
                      <Text style={{ color: PALETTE.secondaryActive }}>{beneficiaryName || getBeneficiaryName(firstName, lastName)}</Text>
                    </NavigationListItemFooter>
                    <NavigationListItemFooter tabIndex={0}>
                      <Text style={{ color: PALETTE.secondaryActive }}>{messages['app.common.portfolio.bonds.account']}: {accountNo || ibanNo}</Text>
                    </NavigationListItemFooter>
                    <NavigationListItemFooter tabIndex={(bank || sortCode?"0":"-1")}>
                      <Text style={{ color: PALETTE.secondaryActive }}>{bank && bank} {sortCode && sortCodeFormat}</Text>
                    </NavigationListItemFooter>
              </React.Fragment>
            :
            <React.Fragment>
                  <NavigationListItemFooter tabIndex={beneficiaryName || getBeneficiaryName(firstName, lastName)?"0":"-1"}>
                    <Text style={{ color: PALETTE.secondaryActive }}>{beneficiaryName || getBeneficiaryName(firstName, lastName)}</Text>
                  </NavigationListItemFooter>
                  <NavigationListItemFooter tabIndex={address1?"0":"-1"}>
                    <Text style={{ color: PALETTE.secondaryActive }}>{address1}{address1 && address2 ? "-" : ""}{address2}</Text>
                  </NavigationListItemFooter>
                  <NavigationListItemFooter tabIndex={sortCode?"0":"-1"}>
                    <Text style={{ color: PALETTE.secondaryActive }}>{sortCode}</Text>
                  </NavigationListItemFooter>
                  <NavigationListItemFooter tabIndex={address3?"0":"-1"}>
                    <Text style={{ color: PALETTE.secondaryActive }}>{address3}</Text>
                  </NavigationListItemFooter>
                  <NavigationListItemFooter tabIndex={0}>
                    <Text style={{ color: PALETTE.secondaryActive }}>{messages['app.common.portfolio.bonds.account']}: {accountNo || ibanNo}</Text>
                  </NavigationListItemFooter>
                  <NavigationListItemFooter tabIndex={bankSwift?"0":"-1"}>
                    <Text style={{ color: PALETTE.secondaryActive }}>{bankSwift}</Text>
                  </NavigationListItemFooter>
                  <NavigationListItemFooter tabIndex={(city || cityName || country)?"0":"-1"}>
                    <Text style={{ color: PALETTE.secondaryActive }}>{city || cityName}{(city || cityName) && postalCode ? ',' : ''}{postalCode}{country ? "-" : ""}{country}</Text>
                  </NavigationListItemFooter>
            </React.Fragment>
        }
        </React.Fragment>
      )
    }
    return (
 
      <NavigationListItem
        tabIndex={-1}
        testID="list_paymentTo_paymentForm_test"
        className="full-height"
        inverse
        role="link"
        hasArrow={false}
        style={{ borderColor: PALETTE.primaryActive }}
        onKeyDown={(e) => this.selectBeneficiary(e)}
        onClick={() => this.selectBeneficiary()}>
        <NavigationListItemHeader color={PALETTE.primaryText} tabIndex={0}> {messages['app.payments.destination.to']}</NavigationListItemHeader>
 
        {content}
        {!isInternal ? <div role ="button" tabIndex={0} aria-label={messages['app.payment.editButton']} className={addBeneficiaryDisabled?"payment-edit-button edit-disabled":"payment-edit-button"} onKeyDown={!addBeneficiaryDisabled?(event) => this.editBeneficiary(event, account):(event)=> {event.stopPropagation()} } onClick={!addBeneficiaryDisabled?(event) => this.editBeneficiary(event, account): (event)=> {event.stopPropagation()}}><EditCircle color={PALETTE.secondaryActive}/></div>:<div></div>}
       
      </NavigationListItem>
 

    )
  }
 
  editBeneficiary = async (event, item) => {
    const {
      payments: { setSelectedBeneficiaryBank, setIBAN, setSelectedBeneficiaryDetail, paymentType },
    } = this.props
    if((event && event.keyCode && (event.keyCode === KEY_CODE.ENTER_KEY || event.keyCode === KEY_CODE.SPACE_KEY)) || (!event)){
      event.stopPropagation();
      this.props.payments.setPaymentEditCapture(item ? true: false); //WMCE-39640 when payment initiate from cash account item will be null.
      item && item.ibanNo ? setIBAN(true) : setIBAN(false);
      if(item === null && (paymentType.includes('international') || paymentType.includes('sepa'))){
        setIBAN(true); //WMCE-40703 UK Web and App- Edit button new beneficiary screen should by default to iban flow
      }

      setSelectedBeneficiaryBank(item);
      setSelectedBeneficiaryDetail(item);

      this.props.changePage(ADD_BENEFICIARY);
    }
  }
 
  handleCheck = async () => {
    const { payments: { setTemplateName, isPaymentTemplateFlow, selectedPaymentTemplate } } = this.props;
    await this.props.payments.toggleSave(!this.props.payments.isSaveEnabled);
    const isEnabled = !this.props.payments.isSaveEnabled;
    if(isEnabled){
      if(isPaymentTemplateFlow){
        this.setState({ currentTemplateName: selectedPaymentTemplate.templateName });
      }else {
        this.setState({ currentTemplateName: "" });
        setTemplateName(null);
     }
    }
  }
 
  handleTemplateName = (event) => {
    const { payments: { setTemplateName } } = this.props;
    this.setState({ currentTemplateName: event.target.value });
    setTemplateName(event.target.value);
  }
 
  saveTemplateView = () => {
    const { i18n: { messages }, payments: { isSaveEnabled } } = this.props;
    return (
      <View style={styles.templateView}>
        <View style={styles.checkBoxView}>
          <Checkbox
            onChange={() => this.handleCheck()}
            className="margin-right-10"
            checked={isSaveEnabled} 
            aria-label={messages['app.payment.templates.saveCheckbox.title']}
            />
          <H3 className='paymentHeading'>{messages['app.payment.templates.saveCheckbox.title']}</H3>
        </View>
        {isSaveEnabled &&
          <View style={styles.templateContainer}>
            <Text className='paymentHeading' style={{ marginBottom: 15, fontSize: 18 }} tabIndex={0}>{messages['app.payment.templates.templateName']}</Text>
            <div aria-label={messages['app.payment.enterTemplateName']}> 
              <TextInput
                onChange={(event) => this.handleTemplateName(event)}
                className="templateName"
                maxLength={35}
                value={this.state.currentTemplateName}
              />
            </div>
         </View>}
      </View>
    );
  }
 
  onModifyTemplate = () => {
    this.setState({ warnModifiedTemplate: false })
    this.props.payments.setSaveModifiedTemplate(true);
    this.props.payments.validatePayment();
    this.props.changePage(TX_SUMMARY);
  }
 
  onNoModifyTemplate = () => {
    this.setState({ warnModifiedTemplate: false })
    this.props.payments.validatePayment();
    // todo: route depends on dwoMessages
    this.props.changePage(TX_SUMMARY);
  }
  
  /* To display warning popup for template modified */
  renderConfirmationModal = () => {
    const { i18n: { messages } } = this.props;
    return (
      <Modal
        isActive={this.state.warnModifiedTemplate}
        style={styles.modalstyle}
        onClose={() => this.setState({ warnModifiedTemplate: false })}
        header={messages['app.warning.text']}
        content={
          <div className="padding-20">
            <div className="small-12 row">
              <div className="column small-1">
              <WarningIcon width={WARNING_ICON.width} height={WARNING_ICON.height} color={PALETTE.warning}/>
              </div>
              <div className="column small-11 padding-left-10 warningPaymentTemplate" tabIndex={0}>
                <Text>{messages['app.payment.templates.modified.template']}</Text>
              </div>
            </div>
            <div className="text-right margin-top-20">
              <Button
                tertiary
                onPress={this.onNoModifyTemplate}
                size="large">
                {messages['app.common.alert.no']}
              </Button>
              <Button
                onPress={this.onModifyTemplate}
                size="large"
              >
                {messages['app.common.alert.yes']}
              </Button>
            </div>
          </div>
        }
      />)
  }
 
  render() {
    const {
      changePage,
      i18n: { messages },
      payments: {
        selectedDebitAcnt,
        selectedBeneficiaryBank,
        selectedBeneficiaryDetail,
        isModifyFlow,
        errorMsgs,
        selectedCreditAcnt,
        amount,
        paymentType,
        toggleConfirmModal,
        setToggleConfirmModal,
        modifyTitle,
        isPaymentTemplateFlow,
        isSaveEnabled,
        selectedPaymentTemplate,
        remarks,
        sepaCountryBicIsoCodeList,
        paymentReason
      },
    } = this.props;

     // WMCE-42144 DWO LUX - International Payment to PSD2-country w/o BEN charging option
     /*Start*/
    const  newSwiftCode =  selectedBeneficiaryBank && selectedBeneficiaryBank.swiftCode && selectedBeneficiaryBank.swiftCode.slice(4,6);
    const  isSwiftCodePresent = sepaCountryBicIsoCodeList && sepaCountryBicIsoCodeList.includes(newSwiftCode);
    /*End*/
    const isInternal = paymentType.includes('internal')
    let pageTitle = messages['app.payment.pageTitle.newDomestic']
    if (isModifyFlow) {
      pageTitle = modifyTitle;
    } else if (isInternal) {
      pageTitle = messages['app.payment.pageTitle.newInternal'];
    } else if (paymentType.includes('international')) {
      pageTitle = messages['app.payment.pageTitle.newInternational'];
    } else if (paymentType.includes("sepa")) {
      pageTitle = messages['app.payment.pageTitle.newSepa'];
    }
    const isUKRegion = (envConfig.envConfig === EBANKINGWEBUK || envConfig.rmRegion === RM_REGION_UK);
 
    const templateValidation = isSaveEnabled ? this.state.currentTemplateName : (!isPaymentTemplateFlow || (isPaymentTemplateFlow && this.state.currentTemplateName));

    const enableValidation = ((selectedBeneficiaryBank || selectedBeneficiaryDetail) || selectedCreditAcnt) && amount && selectedDebitAcnt && templateValidation && (isUKRegion ? (!isEmpty(remarks) && paymentReason) :  (!isEmpty(remarks) ||isEmpty(remarks)) );

    return (
      <div className="payment-page row">
        {errorMsgs && <PaymentError errors={errorMsgs} />}
        <span className="title" id="title_domesticPayment_paymentForm_test">
          <H1 primary tabIndex={0}>{pageTitle}</H1>
        </span>
        {isPaymentTemplateFlow &&
          <View style={styles.row} accessible={true}>
            <Text className='paymentHeading' style={StyleSheet.flatten(styles.templateHeader)}>{messages['app.payment.templates.fromTemplate']}</Text>
            <Text className='margin-left-10' style={StyleSheet.flatten(styles.templateHeader)}>{selectedPaymentTemplate.templateName}</Text>
          </View>
        }
        <div>
          <View style={{ flex: 1, flexDirection: 'row' }}>
 
            <View style={{ flex: 1 }}>
              {/* EDIT HERE FOR INTERNAL */}
              {this.renderToAccount(isInternal ? selectedCreditAcnt : (selectedBeneficiaryBank || selectedBeneficiaryDetail ), messages, isInternal, paymentType)}
            </View>
            <View style={{ flex: 1, marginLeft: 10 }}>
              {/* {selectedDebitAcnt && */}
              {this.renderFromAccount(selectedDebitAcnt, messages, isInternal)}
            </View>
          </View>
          <div className="columns amntSection">
            <View style={{ flex: 1, flexDirection: 'row' }}>
              <View style={{ flex: 1 }}>
                <PymtAmtDetails />
                <PymtDetails isSwiftCodePresent={isSwiftCodePresent}/>
              </View>
              {this.saveTemplateView()}
            </View>
          </div>
          <div align="right" className="resetButtonMargin">
            <Button testID="btn_domesticPayment_paymentForm_test"
              disabled={!enableValidation}
              onClick={enableValidation ? this.onValidateClick : () => { }}
              size="large"
            >
              {messages['app.common.payment.validatepymt']}
            </Button>
          </div>
        </div>
        {this.state.warnModifiedTemplate && this.renderConfirmationModal()}
        {toggleConfirmModal &&
          <FormBackConfirmModal
            messages={messages}
            onConfirm={(e) => this.confirmFormBackConfirm(e)}
            onClose={() => setToggleConfirmModal(false)}
            isModifyFlow={isModifyFlow} />
            }
      </div>
    );
  }
}
 
export default createContainer({
  $renderLoading: () => <LoadingCircle />,
  $queries: {
    app: {
      global: {
        deviceInfo: {
          isTablet: true,
        },
      },
    },
    auth: {
      addBeneficiaryDisabled: true
    },
    i18n: { messages: true },
    changePage: { $call: 'ui.history.push' },
    portfolio: {
      setAssetClassName: { $set: 'assetClassName' }
    },
    payments: {
      isCashFlow: true,
      isCashPaymentFlow: true,
      setIsCashPaymentFlow: { $set: 'isCashPaymentFlow' },
      isModifyFlow: true,
      setDisableTabs: { $set: 'disableTabs'},
      getTemplateList: { $call: 'getTemplateList' },
      templateList: true,
      isPaymentTemplateFlow: true,
      setErrorMsgs: { $set: 'errorMsgs' },
      templateName: true,
      setTemplateName: { $set: 'templateName' },
      selectedDebitAcnt: true,
      paymentReason: true,
      setSelectedDebitAcnt: { $set: 'selectedDebitAcnt' },
      selectedBeneficiaryBank: true,
      modifyTitle: true,
      currentTx: true,
      setBeneficiaryIdToUpdate: { $set: 'beneficiaryIdToUpdate'},
      setExistingBeneficiaryId: { $set: 'existingBeneficiaryId'},
      setIsPymtEditBenef: { $set: 'isPymtEditBenef'},
      validatePayment: { $call: 'validatePayment' },
      errorMsgs: true,
      paymentType: true,
      amount: true,
      loadCreditAccountList: { $call: 'loadCreditAccountList' },
      loadDebitAccountList: { $call: 'loadDebitAccountList' },
      selectedCreditAcnt: true,
      setSelectedCreditAcnt: { $set: 'selectedCreditAcnt' },
      toggleConfirmModal: true,
      setToggleConfirmModal: { $set: 'toggleConfirmModal' },
      isPymtAddNewBenef: true,
      setIsPymtAddNewBenef: { $set: 'isPymtAddNewBenef' },
      setModifyDebitAcntFlag: { $set: 'isModifyDebitAcnt' },
      isPymtEditFrmCaptureScreen: true,
      setDebitAccountFlow: { $set : 'setDebitAccountFlow' },
      setPaymentEditCapture: { $set: 'isPymtEditFrmCaptureScreen' },
      setSelectedBeneficiaryBank: { $set: 'selectedBeneficiaryBank' },
      setIBAN: { $set: 'isIBANSelected' },
      setSelectedBeneficiaryDetail: { $set: 'selectedBeneficiaryDetail' },
      selectedBeneficiaryDetail: true,
      selectedPaymentTemplate: true,
      selectedCurrency: true,
      selectedCost: true,
      remarks: true,
      setSaveModifiedTemplate: { $set: 'saveModifiedTemplate' },
      isSaveEnabled: true,
      toggleSave: { $set: 'isSaveEnabled' },
      saveTemp: { $call: 'saveUpdateTemplate' },
      setSelectedPaymentTemplate: { $set: 'selectedPaymentTemplate' },
      sepaCountryBicIsoCodeList: true
    },
  },
})(PaymentForm);